import { render } from "./MantenedorVideos.vue?vue&type=template&id=fc4e77d4&scoped=true"
import script from "./MantenedorVideos.vue?vue&type=script&lang=js"
export * from "./MantenedorVideos.vue?vue&type=script&lang=js"

import "./MantenedorVideos.vue?vue&type=style&index=0&id=fc4e77d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4e77d4"]])

export default __exports__